<div fxLayout="column" fxLayoutGap="5px">
  <div class="select-all">
    <mat-checkbox *ngIf="showSelectAll" [(ngModel)]="selectAll" [disabled]="selectAllDisabled" color="primary"
      ><b>Select All</b></mat-checkbox
    >
    <div class="group-by">
      <span>Group by:</span>
      <mat-button-toggle-group
        [(ngModel)]="toggleValue"
        name="Group By"
        aria-label="Group people by"
        #group="matButtonToggleGroup"
        (change)="onChange($event)"
      >
        <mat-button-toggle value="positionTitle">Position</mat-button-toggle>
        <mat-button-toggle value="seatStatus">Seat Status</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <ng-container>
    <div
      fxLayout="column"
      fxLayoutGap="5px"
      *ngFor="let positionTitle of getGroupMapKeys()"
      class="grouped-header"
      [attr.aria-label]="positionTitle"
    >
      <mat-checkbox
        color="primary"
        [checked]="getGroupKeyStateForKey(positionTitle)"
        [disabled]="getGroupDisabledStateForKey(positionTitle)"
        (change)="setGroupKeyStateForKey(positionTitle, $event.checked)"
        [attr.aria-label]="'Select all ' + positionTitle + 's'"
      >
        <b>{{ positionTitle }}</b>
      </mat-checkbox>
      <mat-checkbox
        *ngFor="let item of getGroupMapValuesForKey(positionTitle)"
        [(ngModel)]="item[keyName]"
        color="primary"
        [disabled]="isDisabled && item['disabled']"
      >
        {{ getDisplayValue(item) }}
      </mat-checkbox>
    </div>
  </ng-container>
</div>
